/**
 * External dependencies
 */
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { Icon, chevronRight } from '@wordpress/icons';
import Calendar from 'gridicons/dist/calendar';

// Filter to add a new item in the Analytics dropdows.
addFilter( 'woocommerce_admin_products_report_filters', 'woocommerce-bookings/admin/analytics', (filterConfig, variationsConfig) => {
	let valueToPush = { };
	valueToPush["label"] = __( 'Bookable products', 'woocommerce-bookings' );
	valueToPush["value"] = 'bookings';

	filterConfig.forEach( function( obj ) {
		if ( obj.filters ) {
		  obj.filters.push( valueToPush );
		}
	} );

	return filterConfig;
}, 10 );

// Filter to add a new item in the Product Type dropdows.
addFilter( 'experimental_woocommerce_tasklist_product_types',
	'woocommerce-bookings',
	(productTypes) => [
		...productTypes,
		{
			key: 'booking',
			title: __('Bookable Product', 'woocommerce-bookings'),
			content: __('An item that can be rented or reserved. Variations include cost, availability, and number of persons.', 'woocommerce-bookings'),
			before: <Calendar />,
			after: <Icon icon={chevronRight} />,
		},
	]
);
